import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideTranslateLoader,
  provideTranslateService,
  TranslateService,
} from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { ApiTranslateLoader } from './core/i18n/api-translate.loader';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { RestoreSessionService } from './core/services/restore-session.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideTranslateService({
      loader: provideTranslateLoader(ApiTranslateLoader),
      lang: 'ua',
      fallbackLang: 'ua',
    }),
    provideAppInitializer(() => {
      const document = inject(DOCUMENT);
      const session = inject(RestoreSessionService);
      const applicationId = new URLSearchParams(
        document.defaultView?.location.search ?? '',
      ).get('application_id');

      if (applicationId) session.setApplicationId(applicationId);

      return firstValueFrom(inject(TranslateService).use('ua'));
    }),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
  ],
};
